function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Avatar, Button, Tag } from "@t8891/mobile";
import { withNativeProps } from "../../utils/with-native-props";
import cx from "classnames";
var classPrefix = "tc-im-agent-item";
var AgentItem = function AgentItem(props) {
  var avatarSrc = props.avatarSrc,
    brandIcon = props.brandIcon,
    showroomName = props.showroomName,
    name = props.name,
    size = props.size,
    tags = props.tags,
    buttonName = props.buttonName,
    onClickShowroom = props.onClickShowroom,
    onClick = props.onClick,
    tagStyle = props.tagStyle;
  var baseProps = {
    className: cx(classPrefix, _defineProperty({}, "".concat(classPrefix, "-mini"), size === "mini"))
  };
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-right")
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: avatarSrc,
    size: 50,
    border: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-middle")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-brand")
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: "".concat(classPrefix, "-icon"),
    src: brandIcon
  }), name), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-tags")
  }, Array.isArray(tags) && tags.map(function (item, index) {
    return /*#__PURE__*/React.createElement(Tag, {
      style: tagStyle,
      color: item.color,
      fill: 'outline',
      key: index
    }, item.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-showroom"),
    onClick: onClickShowroom
  }, showroomName)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-left")
  }, /*#__PURE__*/React.createElement(Button, {
    className: "".concat(classPrefix, "-btn"),
    type: 'primary',
    size: 'small',
    onClick: onClick,
    block: true
  }, buttonName))));
};
AgentItem.defaultProps = {};
export default AgentItem;